import { HttpHeaders, HttpParams } from '@angular/common/http';

export enum BepatientHttpStatusTextsError {
  NO_NETWORK = '[BepatientHttpStatusTextsError] No Network'
}

export interface CoreHttpError {
  message: string | any;
  name?: string;
  status?: number;
  statusText?: string;
}

export interface CoreHttpRequestOptions {
  headers?: HttpHeaders | { [header: string]: string | string[] };
  observe?: 'body';
  params?: HttpParams | { [param: string]: string | string[] };
  reportProgress?: boolean;
  responseType?: 'json';
  withCredentials?: boolean;
  withMobiCredentials?: boolean;
}
